class Lookup {
  constructor() {
    let search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    let country = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "United States";
    let max_results = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    let include_only_administrative_area = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
    let include_only_locality = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
    let include_only_postal_code = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
    this.result = [];
    this.search = search;
    this.country = country;
    this.max_results = max_results;
    this.include_only_administrative_area = include_only_administrative_area;
    this.include_only_locality = include_only_locality;
    this.include_only_postal_code = include_only_postal_code;
  }

}

module.exports = Lookup;